import React from "react";
import styled from "styled-components";
import { getCommaNumber } from "utils/format";
import type { ServiceBreakdown } from "types/ManagerPayment";
import { SERVICE_COLOR } from "./colors";

interface Props {
  breakdown: ServiceBreakdown;
}

export const ServiceBreakdownList = ({ breakdown }: Props) => {
  const { items, penalty } = breakdown;
  return (
    <List>
      {items.map((it) => (
        <React.Fragment key={it.code}>
          <li className={!it.amount ? "zero" : undefined}>
            <div className="nm">
              <span
                className="dot"
                style={{ background: SERVICE_COLOR[it.code] }}
              />
              <span className="nmt">{it.name}</span>
              <span className="pct">{it.percentage}%</span>
            </div>
            <div className="amt">{getCommaNumber(it.amount)}원</div>
          </li>
          {it.code === "ETC" && penalty?.amount ? (
            <li className="sub">
              <span>└ 위약금(참고, 기타에 포함 — 합산 아님)</span>
              <span>{getCommaNumber(penalty.amount)}원</span>
            </li>
          ) : null}
        </React.Fragment>
      ))}
    </List>
  );
};

const List = styled.ul`
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 0;
    border-top: 1px solid var(--lightBorder);
  }
  li .nm {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  li .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex: none;
  }
  li .nmt {
    font-size: var(--14px);
  }
  li .pct {
    font-size: var(--12px);
    color: #98a0af;
  }
  li .pct:before {
    content: "·";
    margin: 0 0.35em;
  }
  li .amt {
    font-size: var(--14px);
    font-weight: 600;
    text-align: right;
    padding-left: 12px;
    white-space: nowrap;
  }
  li.zero .nmt,
  li.zero .amt,
  li.zero .pct {
    color: #b0b7c3;
  }
  li.sub {
    border-top: none;
    padding: 0 0 11px 16px;
    margin-top: -4px;
  }
  li.sub span {
    font-size: var(--12px);
    color: #8a91a0;
  }
`;

export default ServiceBreakdownList;
